/**
 * @generated SignedSource<<47702f36a39d362bde337357105a058b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontFeaturedSection_seller$data = {
  readonly sellerPreferences: {
    readonly urlLabel: string | null;
  } | null;
  readonly " $fragmentType": "StorefrontFeaturedSection_seller";
};
export type StorefrontFeaturedSection_seller$key = {
  readonly " $data"?: StorefrontFeaturedSection_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontFeaturedSection_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontFeaturedSection_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "kind": "LinkedField",
      "name": "sellerPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "bc08d8a399155d5520d7651d9b726063";

export default node;
